/**
 * Shared styling for the Login / MFA auth flow, used by Login.jsx and
 * MFASecondFactor.jsx.
 */
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { GRADIENT_ICE } from './themeTokens';
import {
  APP_STYLE_COMPONENT_COLORS as MSI_COMPONENT_COLORS,
  MSI_GEOMETRY,
  APP_STYLE_PALETTE as MSI_PALETTE,
  getAppStyleTokens,
  usesAppStyleGrammar,
} from './msiStyleTokens';

export const ICE_GRADIENT = GRADIENT_ICE;
const ICE_GRADIENT_HOVER = 'linear-gradient(90deg, #b9c4ce, #7b8b99)';

export const IceButton = styled(Button)(({ theme }) => ({
  width: '100%',
  marginTop: '16px',
  borderRadius: usesAppStyleGrammar(theme) ? MSI_GEOMETRY.radii.button : '9999px',
  fontFamily: usesAppStyleGrammar(theme) ? theme.typography.fontFamily : "'Poppins', sans-serif",
  fontWeight: 600,
  fontSize: usesAppStyleGrammar(theme) ? '10.5px' : '16px',
  color: usesAppStyleGrammar(theme) ? getAppStyleTokens(theme).actions.primaryText : '#0b1220',
  background: usesAppStyleGrammar(theme) ? MSI_PALETTE.blue600 : ICE_GRADIENT,
  border: usesAppStyleGrammar(theme)
    ? `1px solid ${MSI_COMPONENT_COLORS.primaryBorder}`
    : '1px solid rgba(15, 23, 42, 0.2)',
  boxShadow: usesAppStyleGrammar(theme) ? 'none' : undefined,
  '&:hover': {
    background: usesAppStyleGrammar(theme) ? MSI_COMPONENT_COLORS.primaryHover : ICE_GRADIENT_HOVER,
  },
}));
